import { getAlarmStateProperty } from './getAlarmStateProperty';
import { constructAlarmStreamData } from './constructAlarmStreamData';
import { toDataType } from '../../../time-series-data/util/toDataType';
import { ALARM_STATUS } from '../constants';
/**
 * infer if stream is an AWS IoT Events alarm stream ingested into AWS SiteWise Asset Alarm State Property
 */
const isIoTEventsAlarmStateProperty = (propertyValue) => {
    if (typeof propertyValue === 'string') {
        try {
            const { stateName } = JSON.parse(propertyValue);
            return Object.keys(ALARM_STATUS).includes(stateName.toUpperCase());
        }
        catch (_a) {
            return false;
        }
    }
    return false;
};
export const completeAlarmStream = ({ assetModel, propertyId, dataStream, }) => {
    var _a, _b;
    if (!assetModel) {
        if (isIoTEventsAlarmStateProperty((_b = dataStream.data[((_a = dataStream.data) === null || _a === void 0 ? void 0 : _a.length) - 1]) === null || _b === void 0 ? void 0 : _b.y)) {
            return {
                ...dataStream,
                streamType: 'ALARM',
                data: constructAlarmStreamData({ data: dataStream.data }),
            };
        }
        return;
    }
    const alarmStateProperty = getAlarmStateProperty(assetModel, propertyId);
    if (!alarmStateProperty) {
        return;
    }
    return {
        ...dataStream,
        name: alarmStateProperty.name,
        streamType: 'ALARM',
        data: constructAlarmStreamData({ data: dataStream.data }),
        dataType: toDataType(alarmStateProperty.dataType),
    };
};
